import { STICKER_KEY } from "./constants";
import Storage from "./Storage";

class StickerStorage extends Storage {

	constructor() {
		super(STICKER_KEY);
		this._sticker = JSON.parse(this._storage) || []
	}

	get sticker() {
		return this._sticker;
	}

	set sticker(s) {
		this._sticker = s;
	}

	save() {
		this._storage = JSON.stringify(this._sticker);
		super.save()
	}
}

export default StickerStorage;
export const stickers = new StickerStorage();
